import { render, staticRenderFns } from "./RoleSupport.vue?vue&type=template&id=2ba1c388&scoped=true&"
import script from "./RoleSupport.vue?vue&type=script&lang=js&"
export * from "./RoleSupport.vue?vue&type=script&lang=js&"
import style0 from "./RoleSupport.vue?vue&type=style&index=0&id=2ba1c388&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba1c388",
  null
  
)

export default component.exports